var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTabCamera = function SvgTabCamera(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg5633",
    width: 32,
    height: 32,
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer4",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5653",
    d: "M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0m0 2c7.732 0 14 6.268 14 14s-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect7441",
    d: "M7 10c-.554 0-1 .446-1 1v12c0 .554.446 1 1 1h18c.554 0 1-.446 1-1V11c0-.554-.446-1-1-1zm9 1.5a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect7443",
    width: 6,
    height: 3,
    x: 13,
    y: 8,
    ry: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect7445",
    d: "M8 9h2v2H8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7450",
    d: "M19.932 18.41a2.917 2.674 0 1 1-5.834 0 2.917 2.674 0 1 1 5.834 0",
    transform: "matrix(1.1999 0 0 1.309 -4.417 -7.1)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTabCamera);
export default ForwardRef;